module.exports = __webpack_public_path__ + "img/P150T_weapon_93.b8c5e436.png";